/**
 * Post bids list. Listens for new bids for the given post..
 *
 * @param string uuid
 */
export default function (postId, currentCount) {
    return {
        loaded: false,
        bids: [],
        postId,
        currentCount,
        bidCount: currentCount,
        submitting: false,
        mounted: function () {
            this.loaded = true;

            window.Echo.channel('post-bids.' + this.postId).listen('Bids.BidCreated', (event) => {
                this.bids.push(event);
                this.updateBidCount();
                this.sortBids();
            });
        },
        updateBidCount: function () {
            this.bidCount = this.currentCount + this.bids.length;
        },
        sortBids: function () {
            this.bids = this.bids.sort((a, b) => b.amount - a.amount);
        },
    };
}
